import { updateState, resetState } from './utils';

export default (state: any, action: any) => {
  switch (action.type) {
    case 'SET_DATA':
      return updateState(state, action.value);
    // case 'MODIFY_DATA':
    //   return modifyState(state, action.value);
    case 'RESET':
      return resetState();
    default:
      return state;
  }
};
